import {
  WIDESCREEN_PAGE_HEIGHT_MM,
  WIDESCREEN_PAGE_WIDTH_MM,
} from './pdfLayout';

/** Center x for widescreen 339mm page */
const COVER_CENTER_X_MM = WIDESCREEN_PAGE_WIDTH_MM / 2;

export const SCMI_COVER = {
  backgroundUrl: `${process.env.PUBLIC_URL || ''}/reports/scmi-cover.png`,
  /** Overlays baked-in "Month YYYY" placeholder on cover PNG (bottom-right) */
  footerMonthYear: {
    xMm: WIDESCREEN_PAGE_WIDTH_MM - 15,
    yMm: 182,
    fontSize: 13,
    align: 'right',
    color: [255, 255, 255],
  },
  title: {
    xMm: COVER_CENTER_X_MM,
    yMm: 82,
    fontSize: 32,
    align: 'center',
    color: [255, 255, 255],
    text: 'Daily Report',
    bold: true,
  },
  date: {
    xMm: COVER_CENTER_X_MM,
    yMm: 98,
    fontSize: 22,
    align: 'center',
    color: [255, 255, 255],
    bold: true,
  },
  subtitle: {
    xMm: COVER_CENTER_X_MM,
    yMm: 112,
    fontSize: 16,
    align: 'center',
    color: [255, 255, 255],
    bold: true,
  },
};

/** Content slide layout — aligns with template gold rule (single line, no duplicate) */
export const SCMI_CONTENT = {
  templateLineYMm: 26,
  pageTitleYMm: 17,
  pageSubtitleYMm: 21,
  pageTitleFontSize: 14,
  pageSubtitleFontSize: 9,
};

/** Selkirk brand styling for interior report pages (tuned for 190mm slide height) */
export const SCMI_BRAND = {
  goldRgb: [249, 190, 11],
  logoUrl: `${process.env.PUBLIC_URL || ''}/selkirk-logo.png`,
  logoFallbackUrl: `${process.env.PUBLIC_URL || ''}/selkirk-logo.svg`,
  marginMm: 15,
  logoTopMm: 9,
  logoMaxWidthMm: 20,
  logoMaxHeightMm: 12,
  /** Fixed Y for the single template gold rule on content slides */
  templateLineYMm: 26,
  headerLineWidthMm: 0.6,
  /** Content begins just below the template gold rule */
  contentTopMm: 28,
  footerBoxWidthMm: 12,
  footerBoxHeightMm: 10,
  footerReserveMm: 12,
  pageNumberFontSize: 10,
};

export const DAILY_REPORT_PDF = {
  orientation: 'landscape',
  format: [WIDESCREEN_PAGE_WIDTH_MM, WIDESCREEN_PAGE_HEIGHT_MM],
  marginMm: SCMI_BRAND.marginMm,
  reportTitle: 'SCMI Daily Report',
};

/**
 * Current Drilling Locations map framing for PDF export.
 * Leaflet fitBounds picks zoom automatically (0–18); maxZoom caps how far in it can go.
 * At ~62°N: z14 ≈ 1.5 km/pixel edge, z15 ≈ 750 m, z16 ≈ 375 m (varies with latitude).
 */
export const REPORT_PROGRESS_MAP = {
  /** Padding around in-progress bbox as a fraction of its lat/lon span */
  bufferRatio: 0.18,
  /** Minimum ground margin on each side of the in-progress bbox (metres) */
  minMarginM: 350,
  /** Extra edge clearance after ensuring all holes are inside the bbox (metres) */
  edgeMarginM: 60,
  /** fitBounds pixel padding inside the capture viewport */
  fitPaddingPx: 24,
  /** Leaflet maxZoom for fitBounds — lower widens the view when bounds are tight */
  maxZoom: 15,
};

/** Fixed inset map on drilling-in-progress hole pages (top-right of right panel) */
export const HOLE_INSET_MAP = {
  widthMm: 42,
  heightMm: 42,
  spanM: 300,
  capturePx: 360,
  labelBarHeightMm: 4,
};

/** Absolute placement on content slides — independent of html2canvas scaling */
export function getHoleInsetMapRect(marginMm, contentWidthMm, contentTopMm) {
  return {
    xMm: marginMm + contentWidthMm - HOLE_INSET_MAP.widthMm,
    yMm: contentTopMm,
    widthMm: HOLE_INSET_MAP.widthMm,
    heightMm: HOLE_INSET_MAP.heightMm,
  };
}
